export { default } from './TimelineOppositeContent';
export type * from './TimelineOppositeContent';

export { default as timelineOppositeContentClasses } from './timelineOppositeContentClasses';
export * from './timelineOppositeContentClasses';
